<template>
  <div class="section_inner">
    <v-row class="column">
      <v-col class="px-6 sm-px-2" col="12">
        <h2 class="offers--title" v-html="jobOffersText"  v-if="!isLoading" />
      </v-col>
    </v-row>
    <v-row class="column">
      <v-col class="px-0 pb-0" col="12">
        <SubCategorySelection
          :isLoading="isLoading"
          :isMobile="isMobile"
          :subcats="categories"
          @displayJobsFor="handleDisplayJobsFor"
          @displayAllJobs="handleDisplayAllJobs"
          :companyDisplayUrl="companyDisplayUrl"
          :companyCode="companyCode"
          :companyName="companyName"
          :jobsInCompany="jobsInCompany"
        />
      </v-col>

      <v-col cols="12" class="pa-0">
        <CompanyJobOffers :jobs="subcatJobs" v-if="!isLoading" />
        <Spinner v-if="isLoading" />
        <DrBtn
          v-if="showButton()"
          type-btn="load_jobs_btn "
          :action="loadMore"
          :loader="isLoading"
        >
          הצג לי משרות נוספות
        </DrBtn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { filter, slice, isNil } from 'lodash';
import drushim_lodash from 'lodash';
import { t } from '@/store/modules/homeDrushim/constantsContent';

import SubCategorySelection from '@/components/Company/SubCategorySelection';
import CompanyJobOffers from '@/components/Company/CompanyJobOffers';
import { COMPANY } from '@/lib/api.js';
import Spinner from '@/components/Spinner/Spinner';

const JOBS_LENGTH = 25;
const LOAD_MORE_LENGTH = 10;

export default {
  components: {
    SubCategorySelection,
    CompanyJobOffers,
    Spinner,
  },

  props: {
    jobs: {
      type: Array,
    },
    categories: {
      categories: Object,
    },

    companyName: {
      type: String,
    },
    companyDisplayUrl: {
      type: String,
    },
    companyCode: {
      type: String,
    },

    jobsInCompany: {
      type: Number,
    },
    isMobile: {
      type: Boolean,
    },
  },

  data() {
    return {
      jobsBySubcat: false,
      subcatJobs: null,
      tempSubcat: undefined,
      isLoading: false,
      displayAlljobsInCompany: true,
    };
  },
  created() {
    this.displayJobs();
  },

  computed: {
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {});
    },

    jobOffersText() {
      return (
        t('titles.company.jobs') +
        this.companyName +
        ' ' +
        (!this.isMobile ? '' : '<br/>') +
        t('titles.company.bySubCats')
      );
    },

    jobsToDisplay() {
      return !this.jobsBySubcat ? this.jobs : this.jobsForSubcat;
    },

    jobsForSubcat() {
      let temp = filter(this.jobs, (el) => {
        return el.JobContent.SubCategories[0].NameInHebrew === this.tempSubcat;
      });
      return temp;
    },
  },

  watch: {
    jobsForSubcat() {
      return this.jobsToDisplay;
    },
  },

  methods: {
    showButton() {
      return !this.isLoading && this.areMoreJobs() && isNil(this.tempSubcat);
    },

    areMoreJobs() {
      return this.subcatJobs && this.subcatJobs.length < this.jobsInCompany;
    },

    loadMore() {
      this.subcatJobs = [
        ...this.subcatJobs,
        ...slice(
          this.jobs,
          this.subcatJobs.length,
          this.subcatJobs.length + LOAD_MORE_LENGTH
        ),
      ];
    },

    displayJobs() {
      return isNil(this.tempSubcat)
        ? (this.subcatJobs = slice(this.jobs, 0, JOBS_LENGTH))
        : (this.subcatJobs = this.jobs);
    },

    sendSSA(evenData) {
      this.ssa.logResponse('LogSSA', evenData);
    },
    handleDisplayAllJobs() {
      this.displayAlljobsInCompany = true;
      this.subcatJobs = this.jobs;
      this.tempSubcat - false;
    },

    handleDisplayJobsFor(catdir, companycode, companyDisplayUrl) {
      this.tempSubcat = true;
      this.displayAlljobsInCompany = false;
      this.subcatJobs = null;
      this.isLoading = true;

      this.$axios
        .get(
          `${COMPANY}/category?companyname=${companyDisplayUrl}&companycode=${companycode}&catdir=${catdir}`
        )
        .then((response) => {
          const { ResultList } = response.data;
          this.subcatJobs = [...ResultList];
         drushim_lodashisEmpty(response.data.SSAEvents)
            ? null
            : this.sendSSA(response.data.SSAEvents);
        })
        .catch(function (error) {
          console.error(error);
        });

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
#job-offers {
  margin: 60px auto 0;
  max-width: 1260px;
  color: $company-gray;
}

.company-jobs {
  color: $company-gray;
  font-size: 30px;
  line-height: 0.53;
  text-align: right;
  padding-right: 10px;
}

.offers--title {
  text-align: center;
  padding-bottom: 10px;
}
</style>
